import { injectIntl } from 'react-intl';
import Collection from './Collection';

export default injectIntl(Collection);
